/**
 * Знак DataHunter: монограмма DH и фигурные скобки.
 *
 * Исходник в docs/products/datahunter-store/logo.svg. Здесь он переложен
 * в компонент: цвет монограммы наследуется через currentColor, поэтому
 * знак одинаково читается в тёмной и светлой теме, а скобки сохраняют
 * стальной градиент из оригинала.
 *
 * Идентификатор градиента уникален в пределах документа: два знака на
 * одной странице (шапка и подвал) иначе делили бы одно определение, и
 * при удалении первого второй терял бы заливку.
 */
export function DhLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      role="img"
      aria-label="DataHunter"
      focusable="false"
    >
      <defs>
        <linearGradient id="dh-steel" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#f6f8f9" />
          <stop offset="50%" stopColor="#949ca3" />
          <stop offset="100%" stopColor="#747b81" />
        </linearGradient>
      </defs>
      <circle cx="100" cy="100" r="95" fill="currentColor" />
      <text
        x="100"
        y="105"
        textAnchor="middle"
        dominantBaseline="middle"
        fill="var(--color-bg, #0b0f19)"
        fontFamily="Arial, sans-serif"
        fontWeight="900"
        fontSize="80"
      >
        DH
      </text>
      <text
        x="165"
        y="55"
        textAnchor="middle"
        fill="url(#dh-steel)"
        fontFamily="monospace"
        fontWeight="bold"
        fontSize="60"
      >
        {'{}'}
      </text>
    </svg>
  );
}
